import o1 from 'images/overlays/Kissen_30x30.png';

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

export default importAll(require.context('images/overlays/', false, /\.png$/));
